import src from '../assets/hivegolf.png';
import { imageLogo } from './imageLogo';

/**
 * Hive Golf — hexagonal badge (opaque white ground, as delivered).
 * Was a raster wrapped in <svg><image> as a base64 data URI; now a 20KB
 * quantized first-party asset.
 */
export const HiveGolfLogo = imageLogo({
  src,
  width: 1000,
  height: 1000,
  alt: 'Hive Golf',
});
